/**
 * Web typography mapped to the mobile Nunito faces loaded in
 * learn-hmong/app/_layout.tsx. Tailwind `font-*` weights already match:
 * ExtraLight 200, Light 300, Regular 400, SemiBold 600, Bold 700,
 * ExtraBold 800, Black 900. Italics need the italic faces loaded.
 */

export const NUNITO_STACK = 'Nunito, system-ui, sans-serif';
export const KHULA_STACK = 'Khula, system-ui, sans-serif';

/** Same families/weights as the mobile `useFonts` set (plus Khula wordmark). */
export const APP_GOOGLE_FONTS =
  'https://fonts.googleapis.com/css2?family=Khula:wght@300;400;600;700&family=Nunito:ital,wght@0,200;0,300;0,400;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,600;1,700;1,800;1,900&family=Press+Start+2P&display=swap';

export const clerkAppearance = {
  variables: {
    colorPrimary: '#399918',
    borderRadius: '1rem',
    fontFamily: NUNITO_STACK,
    fontFamilyButtons: NUNITO_STACK,
  },
} as const;

/** Shared class names that lock learner UI to mobile sizes + faces. */
export const typeScale = {
  /** Hub / nav mode wordmark — Nunito-Black 28 green */
  hubTitle: 'font-nunito text-[28px] font-black leading-[34px] text-[#399918]',
  /** Settings / section screens — Nunito-Bold 24 */
  screenTitle: 'font-nunito text-2xl font-bold text-[#1E1E1E]',
  /** Support empty title — Nunito-Bold 22 */
  supportTitle: 'font-nunito text-[22px] font-bold text-[#1E1E1E]',
  /** Hub row headers — Nunito-ExtraBold 18 */
  sectionTitle: 'font-nunito text-lg font-extrabold text-[#1E1E1E]',
  /** Hub "View All" — Nunito-Bold 14 */
  viewAll: 'font-nunito text-sm font-bold text-[#399918]',
  /** ResourceCard category — Nunito-Bold 10 */
  cardCategory: 'font-nunito text-[10px] font-bold uppercase tracking-wide',
  /** ResourceCard title — Nunito-Bold 16 */
  cardTitle: 'font-nunito text-base font-bold leading-tight text-[#1E1E1E]',
  /** ResourceCard subtitle — Nunito-Regular 14 */
  cardSubtitle: 'font-nunito text-sm font-normal',
  /** ResourceCard badge — Nunito-Bold 10 */
  cardBadge: 'font-nunito text-[10px] font-bold',
  /** Search result title — Nunito-Bold 22 */
  searchResultTitle: 'font-nunito text-[22px] font-bold',
  /** Search field — Nunito-SemiBold 16 */
  searchInput: 'font-nunito text-base font-semibold',
  /** Settings card heading — Nunito-Bold 20 */
  settingsCardTitle: 'font-nunito text-xl font-bold text-[#1E1E1E]',
  /** Hero bottom title — Nunito-Bold 17 */
  heroTitle: 'font-nunito text-[17px] font-bold leading-tight',
  /** Hero bottom subtitle — Nunito-Regular 13 */
  heroSubtitle: 'font-nunito text-[13px] font-normal',
  /** Paywall hero — Nunito-Bold 32 */
  paywallTitle: 'font-nunito text-[32px] font-bold leading-tight text-[#1E1E1E]',
  /** CardsBar title — Nunito-SemiBold 18 */
  lessonBarTitle: 'font-nunito text-lg font-semibold text-[#1E1E1E]',
} as const;
